import { render } from "./SendSms.vue?vue&type=template&id=fcb84988&scoped=true"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"

import "./SendSms.vue?vue&type=style&index=0&id=fcb84988&scoped=true&lang=css"
import "./SendSms.vue?vue&type=style&index=1&id=fcb84988&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb84988"]])

export default __exports__